import { render } from "./InternalRoleDashboardView.vue?vue&type=template&id=6db9cbf0"
import script from "./InternalRoleDashboardView.vue?vue&type=script&lang=js"
export * from "./InternalRoleDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__